import {
  mapState, mapActions, mapGetters,
} from 'vuex';
import { get, map } from 'lodash';
import { ATTRIBUTES_FOR_TYPE } from '../../constants';
import { isRackable } from '../../store/helpers';

export default {
  data() {
    return {
      attributesForType: ATTRIBUTES_FOR_TYPE,
    };
  },
  created() {
    this.fetchProducts();
    this.fetchConfigurations();

    if (this.configurationId) {
      this.openConfiguration(parseInt(this.configurationId, 10));
    }
  },
  computed: {
    ...mapGetters('configuration', ['baieElements', 'getQuantityByProduct', 'filteredProducts']),
    ...mapState('configuration', ['filters', 'sortedProducts']),
    configurationId() {
      return this.$route.params.id;
    },
  },
  methods: {
    getConfigurationPath(path = undefined) {
      if (this.configurationId) {
        if (path) {
          return `/uni-baies/configuration/${this.configurationId}${path}`;
        }
        return `/uni-baies/configuration/${this.configurationId}`;
      }
      if (path) {
        return `/uni-baies${path}`;
      }
      return '/uni-baies/configuration';
    },
    productTextAttributes(product) {
      const attributes = [{
        title: 'Réference',
        path: 'reference',
        class: 'has-text-weight-bold has-text-black',
      }].concat(this.attributesForType[product.productable_type]);
      return map(attributes, (attribute) => (
        {
          text: `${attribute.title} : ${this.getProductAttribute(product, attribute.path)}`,
          class: attribute.class,
        }));
    },
    productQuantityText(product) {
      const productQuantity = this.getQuantityByProduct(product);
      if (productQuantity) {
        if (isRackable(product)) {
          return `- ${productQuantity} dans la baie`;
        }
        return `- ${productQuantity} dans la configuration`;
      }
      return '';
    },
    ...mapActions('configuration', ['fetchProducts', 'selectType', 'openConfiguration', 'fetchConfigurations', 'setProductQuantity']),
    resetProductQuantity(product) {
      // eslint-disable-next-line no-param-reassign
      product.quantity = 0;
      this.setProductQuantity({ product, quantity: 0 });
    },
    getProductAttribute(product, path) {
      const value = get(product, path);
      if (typeof value === 'boolean') {
        return value ? 'Oui' : 'Non';
      }
      if (!value) {
        return 'N/A';
      }
      return value;
    },
  },
};
